import Swiper from "swiper/bundle";

(() => {
    const selector = ".swiper-slideshow";
    let swiper = null;
    let swiperHeight = 0;
    let container = document.querySelector(selector);
    let slides = null;

    run();

    window.addEventListener("resize", run);

    function run() {
        if (container && !swiper) {
            swiper = initSwiper();
            slides = document.querySelectorAll(".swiper-slide img");
        }

        if (window.innerWidth > 768) {
            swiperHeight = 800;
        } else {
            swiperHeight = 300;
        }

        if (swiper) {
            swiper.update();
        }
    }

    function update(img) {
        let heightAttr = img.getAttribute("width");
        let widthAttr = img.getAttribute("height");
        let actWidth = img.clientWidth;
        let desc = img.nextElementSibling;
        let actHeight = (actWidth * widthAttr) / heightAttr;
        desc.style.top = (swiperHeight - actHeight) / 2 + actHeight - 10 + "px";
    }

    function initSwiper() {
        return new Swiper(selector, {
            spaceBetween: 30,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            // Enable lazy loading
            lazy: {
                loadPrevNext: true,
            },
            on: {
                lazyImageReady: function (slide, image) {
                    let currentImg = slides[swiper.activeIndex];
                    update(currentImg);
                },

                update: function () {
                    console.log("update");
                    let currentImg = slides[swiper.activeIndex];
                    update(currentImg);
                },

                slideChange: function () {
                    console.log("slide change");
                    let currentImg = slides[swiper.activeIndex];
                    update(currentImg);
                },
            },
        });
    }

    let images = document.querySelectorAll(".slideshow img");

    images.forEach((img) => {
        img.addEventListener("contextmenu", (e) => {
            e.preventDefault();
            return false;
        });
    });
})();
